import React, { useEffect, createElement, Component } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { HowItWorks } from './components/HowItWorks';
import { Features } from './components/Features';
import { IngredientDemo } from './components/IngredientDemo';
import { DownloadCTA } from './components/DownloadCTA';
import { Footer } from './components/Footer';
import { BlogPage } from './components/BlogPage';
import { BlogPost } from './components/BlogPost';
import { AboutPage } from './components/AboutPage';
import { HowToGuide } from './components/HowToGuide';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { TermsOfService } from './components/TermsOfService';
import { ContactSupport } from './components/ContactSupport';
import { EditorialPolicy } from './components/EditorialPolicy';
import { Testimonials } from './components/Testimonials';
import { WhatItDoes } from './components/WhatItDoes';
import { WhyIngredientsMatter } from './components/WhyIngredientsMatter';
import { IngredientCategories } from './components/IngredientCategories';
import { AppScreenshots } from './components/AppScreenshots';
import { FAQ } from './components/FAQ';
import { LatestBlogPosts } from './components/LatestBlogPosts';
// Component to handle scrolling to hash links when navigating from another page
function ScrollToHash() {
  const {
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash.replace('#', ''));
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, [hash]);
  return null;
}
function HomePage() {
  useEffect(() => {
    document.title = 'IntelliEats — Scan Ingredients, Eat Smarter';
    const meta = document.createElement('meta');
    meta.name = 'google-adsense-account';
    meta.content = 'ca-pub-3041826185319356';
    document.head.appendChild(meta);
    let desc = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!desc) {
      desc = document.createElement('meta');
      desc.name = 'description';
      document.head.appendChild(desc);
    }
    desc.content = 'IntelliEats is a free ingredient scanner app that instantly detects unhealthy ingredients in packaged food. Scan any label with your camera to see which ingredients to avoid, limit, or enjoy — and make smarter, healthier choices in seconds.';
    return () => {
      document.head.removeChild(meta);
    };
  }, []);
  return <main data-id="element-0" data-mp="3qdaienujybxn">
      <HeroSection data-id="element-1" data-mp="3qd0tl3l8uatj" />
      <WhatItDoes data-id="element-2" data-mp="3lkr4tqvv7gsu" />
      <HowItWorks data-id="element-3" data-mp="3lk7q0j1ih8j1" />
      <WhyIngredientsMatter data-id="element-4" data-mp="3ljpkevsylhyg" />
      <Features data-id="element-5" data-mp="3limryjfzn7gf" />
      <IngredientCategories data-id="element-6" data-mp="2xuwqt5zt7m70" />
      <IngredientDemo data-id="element-7" data-mp="2xtv609szrlc3" />
      <AppScreenshots data-id="element-8" data-mp="2xtc0jskj2pey" />
      <Testimonials data-id="element-9" data-mp="2xsk2mb3gkfli" />
      <FAQ data-id="element-10" data-mp="2sw207hvlotcc" />
      <LatestBlogPosts data-id="element-11" data-mp="2swbu3gjrnknb" />
      <DownloadCTA data-id="element-12" data-mp="2sv0odb6rg2tk" />
    </main>;
}
export function App() {
  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = 'https://cdn.magicpatterns.com/uploads/kYypn9DLGTyuEjc1d2cJka/intellieats_icon.webp';
  }, []);
  return <BrowserRouter data-id="element-13" data-mp="13cll7il5ezww">
      <ScrollToHash data-id="element-14" data-mp="1r4inoj2pkflc" />
      <div className="min-h-screen bg-white" data-id="element-15" data-mp="1r3zj0422jnp9">
        <Navbar data-id="element-16" data-mp="1r2682ckfahbg" />
        <Routes data-id="element-17" data-mp="1w3c2qfxn8enm">
          <Route path="/" element={<HomePage data-id="element-19" data-mp="1w2asgdogbw6y" />} data-id="element-18" data-mp="1w3vm812xzb3r" />
          <Route path="/blog" element={<BlogPage data-id="element-21" data-mp="1i3kukvtt5shj" />} data-id="element-20" data-mp="1w2ki205l41c4" />
          <Route path="/blog/:slug" element={<BlogPost data-id="element-23" data-mp="1i31ap9klku0v" />} data-id="element-22" data-mp="1i443xo5e78jy" />
          <Route path="/about" element={<AboutPage data-id="element-25" data-mp="1m4mvri7acem5" />} data-id="element-24" data-mp="1i5x9f049rmqd" />
          <Route path="/guides/how-to-scan-pantry" element={<HowToGuide data-id="element-27" data-mp="1m70lrcn3z0mu" />} data-id="element-26" data-mp="1m44nfn7cm9xv" />
          <Route path="/privacy" element={<PrivacyPolicy data-id="element-29" data-mp="6nmbs08tvs34" />} data-id="element-28" data-mp="6nw6g14tinf5" />
          <Route path="/terms" element={<TermsOfService data-id="element-31" data-mp="aqiqhfv8z41s" />} data-id="element-30" data-mp="6qs4rqkkve44" />
          <Route path="/contact" element={<ContactSupport data-id="element-33" data-mp="anwkvlrx2ym7" />} data-id="element-32" data-mp="aqsgv4k7fd80" />
          <Route path="/editorial-policy" element={<EditorialPolicy data-id="element-35" data-mp="qyqb9p4tc98v" />} data-id="element-34" data-mp="qwvsagd3qr7f" />
        </Routes>
        <Footer data-id="element-36" data-mp="m6p3afeoh4on" />
      </div>
    </BrowserRouter>;
}